module.exports = __webpack_public_path__ + "img/7.4c7c8116.jpg";